import React from 'react';
import { 
    EditButton,
    List, 
    Datagrid,
    TextField, 
    TopToolbar,
    DateField,
    CardActions,
    ListButton,
    Show,
    SimpleShowLayout,
    BooleanField
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';
import LinkToCreate from  '../../controls/LinkToCreate';
import PassFail from '../../controls/PassFailField'
import moment from 'moment';
import ErrorBoundary from '../../ErrorBoundary';

const useStyles = makeStyles({

    inlineBlock: {
        display: 'inline-flex', 
        marginRight: '1rem' 
    },
    inlineBlockLeft: {
        display: 'inline-flex',
        float:    'left', 
        marginRight: '1rem' 
    },
    hidden : {
        display: 'none' 
    },
    inputStyle : {
        width :'20px',
    },
    controlInputStyle : {
       width :'70px',
       fontSize: '8'
   },
    labelStyle : {
       width :'40px',
       backgroundColor: 'silver'
   },
   iniLabelStyle : {
       width :'20px',
       backgroundColor: 'silver'
   },
   dateStyle : {
       width: '120px',
       
   },
   tableStyle :{ 
       margin: 'auto',  
       fontSize:'12px', 
       fontWeight:'bold', 
       cellspacing:"3", 
       border:'1px solid  black', 
       width: "100%"
   },
   h3: {
       textAlign: 'center',
       width: '100%'
   },
   clearTableStyle :{ 
       margin: 'auto',  
       fontSize:'12px', 
       fontWeight:'bold', 
       cellspacing:"3", 
       border:'0px solid  black', 
       width: "100%"
   },
   inlineBlock: {
       display: 'inline-flex',
       margin: '5px',
       padding: '5px',
   },

});


const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const CalActions = ({...props}) => (
    <CardActions style={cardActionStyle}>
        <LinkToCreate id={props.filterValues.ins_id} name='Create' path='/cal_STOP_WATCH_a/create' />
        <ListButton basePath={'/calinstrument'} label="Calibration List" />
    </CardActions>
);


const Editable = ({record}) => {
    //console.log(record.editable);
    return record && record.is_qa > 0 ? '' : <EditButton  record={record} label='Update'/> ;
}

const ShowDetails = ({...props}) => {
    const classes = useStyles();
    var days = [];

    console.log(props.record)
    if(props && props.record && props.record.details){
        try{
          days =JSON.parse(props.record.details) 
        } catch(e) {
          days = props.record.details;
        };
    }

    return(
            <table className={classes.tableStyle} >
            <tbody  > 
                <tr>
                    <td>
                    <table className={classes.clearTableStyle}>
                        <tbody>
                            <tr>
                                <td colSpan={4} ><center><h3>STOP WATCH</h3></center></td>
                            </tr>
                            <tr>
                                <td>Center Name:</td><td><TextField source='center'  label=''  /></td>
                                <td>Stopwatch ID:</td><td><TextField source='eq_id'  label='' /></td>
                            </tr>
                        </tbody>
                    </table>
                    </td>
                </tr>
                <tr >
                <td>
                    <table className={classes.tableStyle} >
                    <tbody  > 
                            <tr >
                                <td className={classes.labelStyle}>Master Clock Start Time</td>
                                <td className={classes.controlInputStyle} ><TextField source="st_time"    label="" /></td>
                            </tr>
                            <tr > 
                                    <td className={classes.labelStyle} >Mater Clock Stop Time</td>
                                    <td className={classes.controlInputStyle} ><TextField source="sp_time"    label="" /></td>
                            </tr>
                            <tr > 
                                    <td className={classes.labelStyle} >Master Clock Total Time Elapsed</td>
                                    <td className={classes.controlInputStyle} ><TextField source="m_el"    label="" /></td>
                            </tr>
                            <tr > 
                                    <td className={classes.labelStyle} >Stopwatch Total Time Elapsed </td>
                                    <td className={classes.controlInputStyle} ><TextField source="s_el"    label="" /></td>
                            </tr>
                            <tr > 
                                    <td className={classes.labelStyle} >Variance</td>
                                    <td className={classes.controlInputStyle} ><TextField source="variance"    label="" /></td>
                            </tr>
                            <tr > 
                                    <td className={classes.labelStyle} >Pass or Fail</td>
                                    <td className={classes.controlInputStyle} > {props && props.record && props.record.is_pass &&  props.record.is_pass === 'P' ? 'Pass':
                                                        (props && props.record && props.record.is_pass &&  props.record.is_pass === 'F') ? 'Fail' : ''}</td>
                            </tr>
                            <tr > 
                                    <td className={classes.labelStyle} >Tech (Initial/Date)</td>
                                    <td className={classes.controlInputStyle} ><TechInitDate record={props && props.record} label="" /></td>
                            </tr>
                            <tr > 
                                    <td className={classes.labelStyle} >QA (Initial/Date)</td>
                                    <td className={classes.controlInputStyle} ><QAInitDate record={props && props.record}  label="" /></td>
                            </tr>
                            </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
    )
}

const PostShowActions = () => (
    <TopToolbar>
        <></>
    </TopToolbar>
);

const View= props =>(
    <Show
        {...props}
        /* disable the app title change when shown */
        title=" "
        actions={<PostShowActions />}
    >
        <SimpleShowLayout   >
            <ShowDetails  />    
        </SimpleShowLayout>
    </Show>
);

const TechInitDate= ({record})=>(
    record && record.tech_date ? 
   <>
    {record.tech_init + ' on ' + moment(record.tech_date).format('MM/DD/YYYY')}
   </> : <>{record.tech_init}</>
)

const QAInitDate= ({record})=>(
    record && record.qa_date ? 
   <>
    {record.qa_init + ' on ' + moment(record.qa_date).format('MM/DD/YYYY')}
   </> : <>{record.qa_init}</>
)

export const InsList = ({...props }) => (
<ErrorBoundary>  
    <List 
        {...props}
        perPage={20}
        bulkActionButtons ={false}
        actions={<CalActions/>} 
        title ="Calibration | Stop watch | Anually"
        >
        <Datagrid  expand={<View  {...props}  />} >
            <TextField source="ins_id" label="Equip ID" />
            <PassFail source="is_pass" label="Pass/Fail" />
            <TechInitDate label="Tech Init & Date" />
            <QAInitDate label="QA Init & Date" />
            <Editable />
        </Datagrid>
    </List>
    </ErrorBoundary>  
);


export default InsList;
